import SignInCapture from './SignInCapture'

export default SignInCapture
